import { Component, Input } from '@angular/core';
import { CredentialType } from 'enums/CredentialType';
import { AccountingPlanModel } from 'models/generated/Entities.Accounting.AccountingPlan';
import { ProductPlanModel } from 'models/generated/Entities.GormCrm.ProductPlan';
import { Layout } from 'modules/layout';
import { CustomDatePipe } from 'pipes/custom-date.pipe';
import { PaymentIntervalPipe } from 'pipes/payment-interval.pipe';
import { ProductNamePipe } from 'pipes/product-name.pipe';
import { TranslatePipe } from 'pipes/translate.pipe';
import { CredentialRequired } from 'services/credential.service';

@Component({
	selector: 'invoice-details',
	templateUrl: './invoice-details.component.html',
	imports: [Layout, TranslatePipe, CustomDatePipe, PaymentIntervalPipe, ProductNamePipe]
})
@CredentialRequired(CredentialType.UpdateAccountingPlanStatus)
export class InvoiceDetailsComponent {
	@Input() accountingPlan!: AccountingPlanModel;
	@Input() productPlan!: ProductPlanModel;
	constructor() { }
}
